import instance from "../http";
import { getHeader } from "../../utils/utils";
import { userDocument } from "../../constants/path";

export async function uploadDocumentAPi(_data) {
    const headers = getHeader();
    const response = await instance.post(userDocument.UPLOAD_DOCUMENT, _data, headers);
    return response;
}

export async function documentListingApi(_listingPerPage = 10, _listingPage = 1, type = "", project_uuid, search = '') {
    const headers = getHeader();
    const response = await instance.get(
        userDocument.DOCUMENT_LISTING + `?project_uuid=${project_uuid}&perPage=${_listingPerPage}&page=${_listingPage}${type && `&type=${type}`}${search && `&search=${search}`}`,
        headers
    );
    return response;
}

export async function deleteDocumentApi(_deleteData, project_uuid) {
    const headers = getHeader();
    const response = await instance.delete(
        `${userDocument.DELETE_DOCUMENT}`,
        { data: { documents: _deleteData, project_uuid: project_uuid }, ...headers }
    );
    return response;
}

export async function archiveDocumentApi(document_uuid, project_uuid) {
    const headers = getHeader();
    const response = await instance.patch(userDocument.ARCHIVE_DOCUMENT.replace(":uuid", document_uuid), { project_uuid }, headers);
    return response;
}

export async function favouriteDocumentApi({ uuid, isFavourite }) {
    const headers = getHeader();
    const response = await instance.patch(`${userDocument.FAVOURITE_DOCUMENT}${uuid}/favourite`, { "is_favourite": isFavourite }, headers);
    return response;
}

export async function fetchCrawlledURLS(data) {
    const headers = getHeader();
    const response = await instance.post(`${userDocument.CRAWLLED_DOCUMENT_LINK}`, data, headers);
    return response;
}

export async function crawlDocumentURLS(data) {
    const headers = getHeader();
    const response = await instance.post(`${userDocument.CRAWL_DOCUMENT}`, data, headers);
    return response;
}
